<div class="navi py-3">
  <ng-scrollbar style="height: 300px">
    <ng-container *ngIf="bookingEditorService.corruptedCommercials && bookingEditorService?.corruptedCommercials?.corruptedData.length > 0">
      <h5 class="smallHeader">{{'lang.globals.corruptedCommercials' | translate}}:</h5>
      <a class="navi-item" *ngFor="let commercialEvent of bookingEditorService.corruptedCommercials.corruptedData">
        <div (click)="scrollToView(commercialEvent.commercialData)" class="navi-link">
          <div class="navi-attachment mr-2">
            <sb-comp-medium [background]="true" [customHeight]="'30px'" [customWidth]="'70px'"
                            [medium]="commercialEvent?.commercialData?.data?.commercial?.requirements ? commercialEvent?.commercialData?.data?.commercial?.requirements[0]?.previewMedia : null"></sb-comp-medium>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              {{commercialEvent.commercialData.name}}
            </div>
            <div class="text-muted">
              {{commercialEvent.bookingMessage}}
            </div>
          </div>
        </div>
      </a>
    </ng-container>
    <ng-container *ngIf="bookingEditorService.corruptedCommercials && bookingEditorService?.corruptedCommercials?.toConsider.length > 0">
      <h5 class="smallHeader">{{'lang.globals.toConsider' | translate}}:</h5>
      <a class="navi-item" *ngFor="let commercialEvent of bookingEditorService.corruptedCommercials.toConsider">
        <div (click)="scrollToView(commercialEvent.commercialData)" class="navi-link">
          <div class="navi-attachment mr-2">
            <sb-comp-medium [background]="true" [customHeight]="'30px'" [customWidth]="'70px'"
                            [medium]="commercialEvent?.commercialData?.data?.commercial?.requirements ? commercialEvent?.commercialData?.data?.commercial?.requirements[0]?.previewMedia : null"></sb-comp-medium>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              {{commercialEvent.commercialData.name}}
            </div>
            <div class="text-muted">
              {{commercialEvent.bookingMessage}}
            </div>
          </div>
        </div>
      </a>
    </ng-container>
  </ng-scrollbar>
</div>
